<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="blockquote-container prose with-attribution">
<blockquote class="prose with-attribution">
<div class="paragraph-and-attribution">
<p class="first blockquote-content blockquote-content-prose blockquote-position-first"><i>“If you only knew the magnificence of the three, six, and nine, you would have a key to the universe.”</i></p>
<p class="blockquote-attribution blockquote-position-last">Nikola Tesla, 1856 - 1943</p>
</div>
<hr class="implicit-break"/>
<div class="paragraph-and-attribution">
<p class="first blockquote-content blockquote-content-prose"><i>“…I have created a Ball Lightning, which can be heard on the icy peaks of the Himalayas.”</i></p>
<p class="blockquote-attribution blockquote-position-last">Nikola Tesla</p>
</div>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?31cc1b9f